module.exports = __webpack_public_path__ + "media/app/images/vimeo-c95825a755902191b209896474e19ce9.png";